import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-w-card',
  templateUrl: './w-card.component.html',
  styleUrls: ['./w-card.component.scss']
})
export class WCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
